/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// import "./App.css";
import 'react-phone-input-2/lib/style.css';
// Import Css
import './assets/css/materialdesignicons.min.css';
import './Apps.scss';
import 'react-datepicker/dist/react-datepicker.css';
// import './assets/scss/style.scss'
import '../src/assets/css/font_Sizes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Suspense, lazy, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
// import NavBar from "./common/Forums/NavBar";
import './assets/css/main.css';
import { useDispatch, useSelector } from 'react-redux';
import Footer from './components/AuthPages/Footer1';
import { Spinner } from 'reactstrap';
import NoMatch from './nomatch';
import PrivateRoutes from './components/redux/auth/privateRoutes';
import PublicRoutes from './components/redux/auth/publicRoutes';
import './components/messages/chat.css';
import {
  setDarkTheme,
  setLightTheme,
} from './components/redux/dark-light-theme';
import ThemeSwitcher from './components/snackbar/ThemeSwitcher';
import {
  setCurrentLocation,
  setTempUserData,
} from './components/redux/loginForm';
import axios from 'axios';
import JobHistory from './components/DemoJob/jobHistory';
import PrivacyPolicy from './components/DemoShop/Shop/privacPolicay';
import PrivacyPolicyCookie from './components/DemoShop/Shop/privacPolicayCookie';
const CandidateDetail = lazy(() =>
  import('./components/DemoJob/candidateDetail'),
);
const IndexJob = lazy(() => import('./components/DemoJob/Job/index'));
const JobListFour = lazy(() => import('./components/DemoJob/JobListFour'));
const MyJobs = lazy(() => import('./components/DemoJob/myJobs'));
const JobPrice = lazy(() => import('./components/DemoJob/JobPrice'));
const PageJobApply = lazy(() => import('./components/DemoJob/PageJobApply'));
const SearchCertForm = lazy(() =>
  import('./components/DemoJob/searchCertForm'),
);
const SelectedApplicant = lazy(() =>
  import('./components/DemoJob/selectedApplicant'),
);
const JobContract = lazy(() => import('./components/DemoJob/jobContract'));
const FavItems = lazy(() => import('./components/DemoJob/favItems'));
const PageJobCandidate = lazy(() =>
  import('./components/DemoJob/PageJobCandidate'),
);
const PageJobDetailTwo = lazy(() =>
  import('./components/DemoJob/PageJobDetailTwo'),
);
const CreateJobPost = lazy(() => import('./components/DemoJob/createJob'));
const EditJobPost = lazy(() => import('./components/DemoJob/editJob'));
const ChatScreen = lazy(() => import('./components/messages/message2'));
const AboutUs = lazy(() => import('./components/DemoShop/Shop/aboutUs'));
const FAQS = lazy(() => import('./components/DemoShop/Shop/faq'));
const AllBlog = lazy(() => import('./components/blogPages/allBlog'));
const BlogDetail = lazy(() => import('./components/blogPages/BlogDetail'));
const NavBar = lazy(() => import('./components/DemoShop/Shop/NavBar'));
const PageProfileEdit = lazy(() =>
  import('./components/Account/PageProfileEdit'),
);
const PageCoverLogin = lazy(() =>
  import('./components/AuthPages/PageCoverLogin'),
);
const PageCoverSignup = lazy(() =>
  import('./components/AuthPages/PageCoverSignup'),
);
const PageCoverRePassword = lazy(() =>
  import('./components/AuthPages/PageCoverRePassword'),
);
const VerifyPasswordCode = lazy(() =>
  import('./components/AuthPages/verifyPasswordCode'),
);
const UpdatePassword = lazy(() =>
  import('./components/AuthPages/updatePassword'),
);
const VerifyCode = lazy(() => import('./components/AuthPages/verifyCode'));
const AllNotification = lazy(() =>
  import('./components/snackbar/notificationPage'),
);

function App() {
  const isLogin = useSelector((state) => state.auth.isLogin);
  const isDark = useSelector((state) => state.themeDart.dark);
  const isLight = useSelector((state) => state.themeDart.light);
  const userData = useSelector((state) => state.auth.userData);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const loadTheme = async () => {
      if (isDark) {
        await import('./Apps-dark.scss');
        dispatch(setLightTheme(false));
      } else {
        await import('./Apps.scss');
        dispatch(setLightTheme(true));
        if (isLight === false) {
          window.location.reload();
        }
      }
      document.documentElement.setAttribute(
        'data-bs-theme',
        isDark ? 'dark' : 'light',
      );
      document.documentElement.setAttribute(
        'data-theme',
        isDark ? 'dark' : 'light',
      );
      setIsLoading(false);
    };

    loadTheme();
  }, [isDark, isLight]);

  // const url = 'http://localhost:5000'
  useEffect(() => {
    const BASE_URL =
      'https://werkenindezwembadbranche-6cd12907c5e3.herokuapp.com';

    global.TOKEN = window.localStorage.getItem('werkenDeIn_user_token');
    global.BASEURLAUTH = `${BASE_URL}/api/auth`;
    global.BASEURL = `${BASE_URL}/api`;
    global.UPLOADURL = `${BASE_URL}/api/image/upload`;
    global.BASEURLMSG = BASE_URL;
    ////loca
    // global.BASEURLAUTH = `http://localhost:5000/api/auth`;
    // global.BASEURL = `http://localhost:5000/api`;
    // global.UPLOADURL = `http://localhost:5000/api/image/upload`
    // global.BASEURLMSG = 'http://localhost:5000'
    window.scroll(0, 0);
  }, [location]);
  const getLocation = () => {
    // setLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const response = await axios.get(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyBH0Ey-G2PbWkSCLyGG1A9TCg9LDPlzQpc`,
            );
            const address =
              response.data.results[1] || response.data.results[0];
            dispatch(setCurrentLocation(address));
          } catch (error) {
            console.error('Error fetching address:', error);
          } finally {
            // setLoading(false);
          }
        },
        (error) => {
          console.error('Error getting geolocation:', error);
          //   setLoading(false);
        },
      );
    } else {
      console.log('Geolocation is not supported by this browser.');
      //   setLoading(false);
    }
  };
  useEffect(() => {
    getLocation();
  }, []);
  const extractPathFromLocation = (target) => {
    const pathSegments = location.pathname.split('/');

    const index = pathSegments.indexOf(target);
    return index !== -1 ? `/${pathSegments[index]}` : '';
  };
  const requiredPath = extractPathFromLocation('search-cert-form');
  const excludedPaths = [
    '/login',
    '/signup',
    '/pdf-viewer',
    requiredPath,
    '/forgot-password',
    '/code-verify',
    '/chat',
    '/verify-password-code',
    '/update-password',
  ];
  const excludedNavPath = ['/pdf-viewer', requiredPath];
  return (
    <>
      <div className={`${isDark && 'isDark'}`}>
        {!excludedNavPath.includes(location.pathname) && (
          <>
            {location.pathname.startsWith('/search-cert-form') ? null : (
              <NavBar />
            )}
          </>
        )}

        <Suspense
          fallback={
            <div className="w-100 vh-100 main_app d-flex justify-content-center align-items-center">
              <Spinner />
            </div>
          }
        >
          <ThemeSwitcher />
          <Routes>
            <Route element={<IndexJob />} path="/" />
            <Route element={<FAQS />} path="/faq" />
            <Route element={<AboutUs />} path="/about-us" />
            <Route element={<AllBlog />} path="/blog" />
            <Route element={<PrivacyPolicy />} path="/privacy-policy" />
            <Route element={<BlogDetail />} path="/blog-detail/:id" />
            <Route element={<PageJobDetailTwo />} path="/job-detail/:id" />
            <Route element={<JobListFour />} path="/job-list/:id?" />
            <Route
              element={<SearchCertForm />}
              path="/search-cert-form/:id/:token"
            />
            <Route element={<PrivacyPolicyCookie />} path="/privacy-cookies" />
            <Route
              element={
                userData?.type === 'candidates' ? (
                  <Navigate replace to="/" />
                ) : (
                  <JobPrice />
                )
              }
              path="/job-price"
            />
            <Route element={<PrivateRoutes />}>
              <Route element={<FavItems />} path="/fav-items" />
              <Route element={<AllNotification />} path="/notification" />
              <Route element={<JobHistory />} path="/apply-job-history" />
              <Route element={<ChatScreen />} path="/chat" />
              <Route
                element={
                  userData?.type === 'candidates' ? (
                    <Navigate replace to="/" />
                  ) : (
                    <CreateJobPost />
                  )
                }
                path="/create-Job"
              />
              <Route element={<MyJobs />} path="/my-jobs" />
              <Route element={<PageProfileEdit />} path="/account" />
              <Route element={<PageJobApply />} path="/job-apply/:id" />
              <Route
                element={
                  userData?.type === 'candidates' ? (
                    <Navigate replace to="/" />
                  ) : (
                    <SelectedApplicant />
                  )
                }
                path="/candidate-list"
              />
              <Route
                element={
                  userData?.type === 'candidates' ? (
                    <Navigate replace to="/" />
                  ) : (
                    <CandidateDetail />
                  )
                }
                path="/candidate-detail/:id"
              />
              <Route
                element={
                  userData?.type === 'candidates' ? (
                    <Navigate replace to="/" />
                  ) : (
                    <EditJobPost />
                  )
                }
                path="/edit-job/:id"
              />
              <Route element={<JobContract />} path="/job-contract/:id" />
              <Route
                element={
                  userData?.type === 'candidates' ? (
                    <Navigate replace to="/" />
                  ) : (
                    <PageJobCandidate />
                  )
                }
                path="/applicant-detail/:id"
              />
            </Route>
            <Route path="*" element={<NoMatch />} />
            <Route element={<PublicRoutes />}>
              <Route element={<PageCoverLogin />} path="/login" />
              <Route element={<VerifyCode />} path="/code-verify" />
              <Route
                element={<PageCoverRePassword />}
                path="/forgot-password"
              />
              <Route element={<PageCoverSignup />} path="/signup" />
              <Route
                element={<VerifyPasswordCode />}
                path="/verify-password-code"
              />
              <Route element={<UpdatePassword />} path="/update-password" />
            </Route>
          </Routes>
          {!excludedPaths.includes(
            requiredPath === '/search-cert-form'
              ? requiredPath
              : location.pathname,
          ) && <Footer />}
        </Suspense>
      </div>
    </>
  );
}

export default App;
